import styled from 'styled-components';
import { Button } from 'ui/button';
import { Edit16 } from 'ui/icons';
import { spacing } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { InputText } from 'ui/inputs';

export const EditIcon = styled(Edit16)`
  margin: 0 0 0 15px;
  flex-shrink: 0;
  &:hover {
    cursor: pointer;
  }
`;

export const EditMode = styled.div`
  display: flex;
`;

export const InlineButton = styled(Button)`
  margin-left: 5px;
`;

export const NodeTitleText = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const NodeTitleTextDisplay = styled.span`
  word-wrap: break-all;
  line-break: anywhere;
  overflow-wrap: anywhere;
  padding-right: ${spacing.single};
`;

export const FullWidthTextInput = styled(InputText)`
  width: 100%;
`;

export const StyledTooltip = styled(Tooltip)`
  overflow-x: hidden;
`;
